// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalHeader__header--blue--2sxco","divider":"GlobalHeader__divider--blue--1E3Vr"};
    if(module.hot) {
      // 1605595221123
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  